import { render, staticRenderFns } from "./ExchangeItem.vue?vue&type=template&id=75b25e3a&"
import script from "./ExchangeItem.vue?vue&type=script&lang=js&"
export * from "./ExchangeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports